export * from './helpers';
export { LocalizationModule } from './localization.module';
export { LocalizationService } from './services/localization.service';
export { TranslateService } from '@ngx-translate/core';



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/localization/index.ts